import api from "./api";
import { API_BRANCHES } from "../constants/urls";
import { company } from "./companies";

/**
 * Servicio para buscar, crear, modificar y eliminar sucursales
 * Definición del objecto de sucursales
 * @param {object} branch Branch object
 * @param {string} branch.name nombre de la sucursal
 * @param {string} branch.direccion Dirección de la sucursal
 * @param {string} branch.estado Estado donde reside la sucursal
 * @param {string} branch.pais País donde reside la sucursal
 * @param {string} branch.latitude latitud geográfica de la sucursal
 * @param {string} branch.longitude Longitud geográfica de la sucursal
 * @param {object} branch.company Compañía a la cual pertenece la sucursal.
 * @param {number} branch.company.id Id de la compañía a la cual pertenece la sucursal.
 * @param {string} branch.timeZone Zona Horaria
 * @returns
 */

export const branch = {
    getAll: async () => {
        // Toda la logica es para buscar la compania padre de
        // cada sucursal, con cambios del back para que lo devuelva
        // ya no seria necesario
        const companies = await company.getAll();
        let branches = (await api.get(API_BRANCHES)).data;
        branches = Array.from(branches)?.map((branch) => {
            for (let company of companies) {
                const branchesIds = company.branchList?.map(
                    (branch) => branch.id
                ) ?? [];
                if (Array.from(branchesIds).includes(branch.id)) {
                    branch.company = company;
                    return branch;
                }
            }
        });
        return branches;
    },
    getById: async (id) => (await api.get(`${API_BRANCHES}/${id}`)).data,
    create: async (branch) => (await api.post(API_BRANCHES, branch)).data,
    update: async (branch) =>
        (await api.put(`${API_BRANCHES}/${branch.id}`, branch)).data,
    delete: async (id) => (await api.delete(`${API_BRANCHES}/${id}`)).data,
};
